import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { Information } from '@components/UI/Information'
import { IApplicationState } from '@store'
import { selectCampaignOperatingRegionTaxName } from '@store/campaigns'
import Theme from '@theme'
import { Container, Header, Text } from '@tribegroup'

interface IProps {
  title: string
  campaignId: number
  currency: string
}

const PostCampaignReportSubmissionListPerformanceLabelWithTooltip: React.FC<IProps> = ({
  title,
  campaignId,
  currency,
}) => {
  const intl = useIntl()
  const taxDisplay = useSelector((state: IApplicationState) =>
    selectCampaignOperatingRegionTaxName(state, campaignId, intl, currency),
  )
  return (
    <Container width="fit-content" inlineBlock pointer>
      <Information
        delay={1}
        width={15}
        target={
          <Text xsmall color={Theme.grey700Color} uppercase>
            <FormattedMessage id={`postCampaignReport.submission.list.performance.${title}`} />
          </Text>
        }
      >
        <Header
          textAlign="left"
          small
          uppercase
          color={Theme.secondaryColor}
          bottomOuterSpacing={0.5}
        >
          <FormattedMessage
            id={`postCampaignReport.submission.list.performance.${title}.tooltip.header`}
          />
        </Header>
        <Text textAlign="left" color={Theme.defaultColor} customFontSize={0.8125}>
          <FormattedMessage
            id={`postCampaignReport.submission.list.performance.${title}.tooltip`}
            values={{ taxDisplay }}
          />
        </Text>
      </Information>
    </Container>
  )
}

export { PostCampaignReportSubmissionListPerformanceLabelWithTooltip }
export default PostCampaignReportSubmissionListPerformanceLabelWithTooltip
